import { LogType } from "@/constants/app.enums";
import { ReloadOutlined } from "@ant-design/icons";
import { Button, DatePicker, Divider, Drawer, Form, FormProps } from "antd";
import Input from "antd/es/input";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DATE_TIME_FORMAT } from "../../../../../constants/app-constants";
import { TypeFilter } from "../../../../../models/audit-log";
import "./drawer-filter.scss";

export interface DrawerFilterProps {
  openDrawer: boolean;
  onClose: () => void;
  filterData: any;
  type: LogType;
  handleFilterData: (data: object) => void;
  setPageNumber: (data: number) => void;
}

const dataLogStatus: TypeFilter[] = [
  { key: 1, type: "InProgress", value: "1" },
  { key: 2, type: "Error", value: "2" },
  { key: 3, type: 'Success', value: "3" },
];

const { RangePicker } = DatePicker;

function TypeFilterRender(props: {
  filters: TypeFilter[];
  onSelect: (value: string) => void;
  selectedFilters: string[];
}) {
  return (
    <>
      {props.filters.map((filter) => (
        <Button
          className={`tag ${props.selectedFilters.includes(filter.type) ? "selected" : ""
            }`}
          key={filter.key}
          value={filter.value}
          onClick={() => props.onSelect(filter.type)}
        >
          {filter.type}
        </Button>
      ))}
    </>
  );
}

type FieldType = {
  ipFilter?: string;
  loginNameFilter?: string;
  dateTimeFilter?: Date[];
};

function DrawerFilter(props: DrawerFilterProps) {
  const { t } = useTranslation();
  const [drawerForm] = Form.useForm();
  const [selectedFilters, setSelectedFilters] = useState<string[]>(
    props.filterData.statusFilter ?? []
  );

  const handleSelectFilter = (value: string) => {
    if (selectedFilters.includes(value)) {
      setSelectedFilters(selectedFilters.filter((filter) => filter !== value));
    } else {
      setSelectedFilters([...selectedFilters, value]);
    }
  };

  const handleReloadFilter = () => {
    setTimeout(() => {
      drawerForm.resetFields();
    }, 0);
    setSelectedFilters([]);
    props.handleFilterData({});
    props.setPageNumber(1);
  };

  const handleSearch = (values: FormProps<FieldType>) => {
    props.handleFilterData({ ...values, statusFilter: selectedFilters });
    props.setPageNumber(1);
  };

  return (
    <>
      <Drawer
        placement="right"
        onClose={props.onClose}
        closable={true}
        width={432}
        open={props.openDrawer}
        extra={
          <>
            <span> {t("userMenu.filter")}</span>
            <i className="reload-btn" onClick={handleReloadFilter}>
              <ReloadOutlined />
            </i>
          </>
        }
      >
        <Form
          form={drawerForm}
          layout="vertical"
          className="drawer-form"
          onFinish={handleSearch}
          initialValues={{ ...props.filterData }}
        >
          <p></p>
          <Form.Item label={t("drawer.operationTime")}  name="dateTimeFilter">
            <RangePicker className="input-base"
              style={{ width: 398, color: "#0078D7"}}
              showTime={{ format: DATE_TIME_FORMAT.rangePickerHourFormat }}
              format={DATE_TIME_FORMAT.rangePickerFormat}
            />
          </Form.Item>
          {props.type !== LogType.TransactionLog && (
            <>
              <Form.Item label="Search by User Email" name="loginNameFilter">
                <Input className="input-base" placeholder="Enter email" />
              </Form.Item>
              <Form.Item label="Search by IP" name="ipFilter">
                <Input className="input-base" placeholder="Search by IP" />
              </Form.Item>
            </>
          )}

        {props.type === LogType.TransactionLog && (
            <>
              <Form.Item label="Search by Transaction" name="transactionId">
                <Input className="input-base" placeholder="Enter transaction" />
              </Form.Item>
              <Form.Item label="Search by Sender"  name="sender">
                <Input className="input-base" placeholder="Enter sender" />
              </Form.Item>
              <Form.Item label="Search by Receiver" name="receiver">
                <Input className="input-base" placeholder="Enter receiver" />
              </Form.Item>
            </>
          )}


          <div className="logStatus">
            <Divider />
            <p>{t("drawer.logStatus")}</p>
            <TypeFilterRender
              filters={dataLogStatus}
              onSelect={handleSelectFilter}
              selectedFilters={selectedFilters}
            />
          </div>
          <div className="btn-search-container">
            <Button className="btn-search" htmlType="submit">
              {t("userMenu.search")}
            </Button>
          </div>
        </Form>
      </Drawer>
    </>
  );
}

export default DrawerFilter;
